import * as React from 'react'
import './styles.css'

interface IProps {
    checked: boolean;
    value: string;
    onChange: (val: string, checked: boolean) => void
}


const Checkbox: React.StatelessComponent<IProps> = (props) => {
    return (
        <div className="checkbox">
            <label>
            <input 
                type="checkbox" 
                value={props.value} 
                checked={!!props.checked}
                onChange={e => {
                    props.onChange(props.value, !props.checked)}
                } />
                <span className="cr">
                    <i className="cr-icon glyphicon glyphicon-ok" />
                </span>
            </label>
        </div>
    )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.tsx